export default "__VITE_ASSET__CBm6J4nK__"